import { render, staticRenderFns } from "./BillCardIsPaid.vue?vue&type=template&id=6606363a&scoped=true&"
import script from "./BillCardIsPaid.vue?vue&type=script&lang=ts&"
export * from "./BillCardIsPaid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606363a",
  null
  
)

export default component.exports